import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger, } from '../../../../components/shareable/dropdownMenu';
import { MoreVertical } from 'lucide-react';

// Mirrors conveyorTable.js so the Master Price List reads/behaves like the Modular Conveyor page.
// No image column — catalog products are decoupled from image filenames (the point of the refactor).
const CatalogTable = ({ products, currentPage, onUpdate, itemsPerPage }) => {
  const money = (n) =>
    n === null || n === undefined ? <span className="italic text-gray-400">N/A</span> : `$${Number(n).toLocaleString()}`;

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
      <table className="min-w-full divide-y divide-gray-200 bg-white">
        <thead className="bg-gray-50">
          <tr>
            {['#', 'SKU (Part No.)', 'Description', 'Type', 'Image', 'Our Cost', 'List Price', 'Actions'].map((h) => (
              <th key={h} className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {products.length > 0 ? (
            products.map((p, index) => (
              <tr key={p.sku} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm font-mono font-semibold text-gray-900 text-center">
                  {p.sku}
                  {p.list === 0 && (
                    <span className="ml-2 rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-sans font-medium text-gray-500">
                      call for price
                    </span>
                  )}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 max-w-xs">
                  <div className="line-clamp-2 break-words min-h-[2.5rem] flex items-center justify-center text-center">
                    {p.module_description || <span className="italic text-gray-400">No Description</span>}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center uppercase">
                  {p.kind || <span className="italic text-gray-400">N/A</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 text-center">
                  {p.image_name || <span className="italic text-gray-400">N/A</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">{money(p.babs_cost)}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-gray-900 text-center">{money(p.list)}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  <DropdownMenu>
                    <DropdownMenuTrigger className="focus:outline-none">
                      <MoreVertical className="h-5 w-5 text-gray-500 hover:text-blue-600 transition-colors mx-auto" />
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-44 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                      <DropdownMenuLabel className="px-3 py-2 text-xs font-medium text-gray-500 text-center">
                        Actions
                      </DropdownMenuLabel>
                      <DropdownMenuItem
                        onClick={() => onUpdate(p)}
                        className="cursor-pointer px-3 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                      >
                        Update Price
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className="px-6 py-8 text-center text-sm text-gray-500">
                <div className="flex flex-col items-center justify-center">
                  <svg className="w-12 h-12 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  No products available
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CatalogTable;
